import { ModuleManager } from "@lib/ModuleSystem";
import { createRouter, createWebHistory } from "vue-router";
import CallPage from "../views/CallPage.vue";
import AgentPreview from "../views/AgentPreview.vue";
import CallEnded from "../views/CallEnded.vue";
import PageNotFound from "../views/NotFound.vue";
import Warmup from "@/views/Warmup.vue";

const singleton = {
  router: null,
};

function dynamicRouter() {
  if (singleton.router) {
    return singleton.router;
  }
  singleton.router = createRouter({
    history: createWebHistory(),
    routes: [
      ...ModuleManager.routes,
      {
        path: "/warmup",
        name: "warmup",
        component: Warmup,
      },
      {
        path: "/r/:rtcId",
        name: "video-call-page",
        props: true,
        component: CallPage,
      },
      {
        path: "/agent-preview",
        name: "agent-preview",
        props: true,
        component: AgentPreview,
      },
      {
        path: "/agent",
        name: "call-ended",
        component: CallEnded,
      },
      { path: "/:pathMatch(.*)*", name: "not-found", component: PageNotFound },
    ],
  });
  return singleton.router;
}

export { dynamicRouter, singleton };
